<div class="mp-card-row" *ngIf="!mpCardsContent?.error; else mpCardsErrorContent">
  <div class="mp-card" *ngFor="let mpCard of mpCardsContent?.content">
    <div [innerHtml]="mpCard?.value?.body"></div>
    <div class="mp-action">
      <a id="seeMoreLink" tabindex="0" (click)="navigateTo(mpCard?.value?.heading)"
        (keydown.enter)="navigateTo(mpCard?.value?.heading)" aria-label="See More">
        See More
      </a>
    </div>
  </div>
</div>

<div *ngIf="!announcements?.error; else announcementsErrorContent">
  <div *ngIf="announcements?.content?.length">
    <h3>{{announcements?.content[0]?.value?.heading}}</h3>
    <hr class="mp-announcements-hr">
    <div>
      <div [innerHtml]="announcements?.content[0]?.value?.body"></div>
    </div>
  </div>
</div>

<!-- Error Content -->
<ng-template #mpCardsErrorContent>
  <p>There was an unexpected error. Please refresh the page or try again later.</p>
</ng-template>

<ng-template #announcementsErrorContent>
  <h3>Announcements</h3>
  <p>There was an unexpected error. Please refresh the page or try again later.</p>
</ng-template>